import { render, staticRenderFns } from "./TaskCompletedNotification.vue?vue&type=template&id=5ba0f9d4"
import script from "./TaskCompletedNotification.vue?vue&type=script&lang=js"
export * from "./TaskCompletedNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports